import React, { useEffect } from 'react';
import { get, lowerCase } from 'lodash';
import { useIntl } from 'react-intl';
import { object, func, arrayOf, bool, string } from 'prop-types';

import { FormAutoCompleteCombo } from '../../components';
import { getI18n } from '../../utils/intl';

const MINUTE = 'MINUTE';

export const RateQuotaSelect = (props) => {
  const {
    rateLimitQuotas,
    featureFlagDistributeRateLimit,
    onRateLimitSelect,
    selectedRateLimitQuota,
    id,
    isSecondaryText,
    labelText,
    error,
    name,
  } = props;

  const intl = getI18n(useIntl());
  const noneLabel = intl.getI18nMessage('label.none');
  const secLabel = intl.getI18nMessage('label.sec');
  const minLabel = intl.getI18nMessage('label.min');
  const rateLabel = intl.getI18nMessage('label.rate.quota.limit.rate.text');
  const quotaLabel = intl.getI18nMessage('label.rate.quota.limit.quota');
  const dLabel = intl.getI18nMessage('label.rate.quota.limit.distributedrate');

  useEffect(() => {
    if(rateLimitQuotas.length > 0) {
      rateLimitQuotas.map(item => {
        const limit = get(item, 'rateLimit.maxRequestsPerSecond') ? `${get(item, 'rateLimit.maxRequestsPerSecond')} / ${secLabel}` : noneLabel;
        const dInterval = get(item, 'distributedRateLimit.interval') === MINUTE ? `/ ${minLabel}` : `/ ${secLabel}`;
        const dLimit = get(item, 'distributedRateLimit.maxRequests') ? `${get(item, 'distributedRateLimit.maxRequests')} ${dInterval}` : noneLabel;
        const quota = get(item, 'quota.quota') ? `${get(item, 'quota.quota')} / ${lowerCase(get(item, 'quota.interval'))}`
        : noneLabel;
        item.secondaryText = featureFlagDistributeRateLimit ? `${dLabel}: ${dLimit}; ${rateLabel}: ${limit}; ${quotaLabel}: ${quota}`
        : `${rateLabel}: ${limit}; ${quotaLabel}: ${quota}`;
      });
    }
  }, [rateLimitQuotas]);

  return (
    <FormAutoCompleteCombo
      data={rateLimitQuotas}
      selectedValues={selectedRateLimitQuota}
      onChange={(e, value) => onRateLimitSelect(value)}
      isSecondaryText={isSecondaryText}
      loading={true}
      id={id}
      data-apim-test={id}
      inputLabel={labelText}
      error={error}
      name={name}
    />
  )
}

RateQuotaSelect.propTypes = {
  rateLimitQuotas: arrayOf(object),
  featureFlagDistributeRateLimit: bool,
  onRateLimitSelect: func,
  selectedRateLimitQuota: object,
  id: string,
  isSecondaryText: bool,
  labelText: string,
  error: bool,
  name: string,
};

export default RateQuotaSelect;
